export function decodeBase64FromDataURL(dataURL: string): string {
  let toReturn = '';
  if (dataURL) {
    const dataUrlSplitted = dataURL.split(';');
    if (dataUrlSplitted?.length) {
      const strToSearch = 'base64,';
      for (let indexSplitted = 0; indexSplitted < dataUrlSplitted.length; indexSplitted++) {
        const base64Pos = dataUrlSplitted[indexSplitted].indexOf(strToSearch);
        if (dataUrlSplitted[indexSplitted].indexOf(strToSearch)>= 0) {
          toReturn = atob(dataUrlSplitted[indexSplitted].substr(base64Pos + strToSearch.length));
          return toReturn;
        }
      }
    }
  }
  return toReturn;
}
